export const PROGRESS_BAR_COLORS = {
  POST_PLUS: '#ffb53f',
  MARKETPLACE: '#bb236f'
}
